var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpenseChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166626,
    width: 3.42857,
    height: 24,
    rx: 1.71428,
    fill: "#FB940E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.02356,
    y: 6.54541,
    width: 3.42857,
    height: 17.4545,
    rx: 1.71428,
    fill: "#FB940E",
    fillOpacity: 0.47
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.881,
    y: 16.3636,
    width: 3.42857,
    height: 7.63636,
    rx: 1.71428,
    fill: "#FB940E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7379,
    y: 3.27271,
    width: 3.42857,
    height: 20.7273,
    rx: 1.71428,
    fill: "#FB940E",
    fillOpacity: 0.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseChart);
export default __webpack_public_path__ + "static/media/expenseChart.db14913bf6a72c3a94b36372a1ddd0df.svg";
export { ForwardRef as ReactComponent };